module.exports = new Promise((resolve, reject) => {
      if (!window.__REMOTES__) return reject(new Error('__REMOTES__ not initialized'));
      var url = window.__REMOTES__['commons'];
      if (!url) return reject(new Error('No remote URL for commons'));
      if (window['commons']) return resolve(window['commons']);
      var script = document.createElement('script');
      script.src = url;
      script.onload = function() { resolve(window['commons']); };
      script.onerror = function() { reject(new Error('Failed to load ' + url)); };
      document.head.appendChild(script);
    });